import React from 'react'
import { useSelector } from 'react-redux'
import { isEmpty } from 'lodash'
import pluralize from 'pluralize'

import { exportCsv } from '@/components/helpers/exportToCsv'
import { parseToCsv } from '@/components/helpers/parseToCsv'
import { getUpdatedPostcallTranscript } from '@/views/Calls/CallExplorer.helpers'
import { ActionsDropdown } from '@/components/dropdowns/ActionsDropdown'

export const DownloadDropdown = ({
  isAudioAvailable,
  audioError,
  isVideoAvailable,
  videoError,
}) => {
  const {
    callExplorer: { postcall_transcript: postcallTranscript, callId },
  } = useSelector((state) => state.callSearch)
  const { audioUrl, videoUrls } = useSelector((state) => state.media.mediaPlayer)
  const showDownloadAudioOption = isAudioAvailable && !audioError
  const showDownloadTranscriptOption = !isEmpty(postcallTranscript)
  const showDownloadScreenCaptureOption = isVideoAvailable && !videoError
  // most orgs don't have screen capture, so we don't condition the download all button on that
  const showDownloadAllOption = showDownloadAudioOption && showDownloadTranscriptOption
  const showNothing =
    !showDownloadAudioOption && !showDownloadTranscriptOption && !showDownloadScreenCaptureOption

  const handleDownloadAudio = () => {
    window.open(audioUrl)
  }

  const handleDownloadScreenCapture = () => {
    for (const url of videoUrls) {
      window.open(url)
    }
  }

  const handleDownloadTranscript = () => {
    const headers = [
      { accessor: 'side', label: 'Side' },
      { accessor: 'data', label: 'Text' },
      { accessor: 'timestamp', label: 'Timestamp' },
    ]

    const updatedTranscript = getUpdatedPostcallTranscript(postcallTranscript)
    const csvString = parseToCsv({ data: updatedTranscript, headers })
    exportCsv(csvString, null, callId, 'Balto Transcript for Call ID')
  }

  if (showNothing) {
    return null
  }

  const actions = []

  if (showDownloadAllOption) {
    actions.push({
      label: 'Download All Assets',
      onClick: () => {
        handleDownloadAudio()
        handleDownloadTranscript()

        if (showDownloadScreenCaptureOption) {
          handleDownloadScreenCapture()
        }
      },
    })
  }

  if (showDownloadAudioOption) {
    actions.push({ label: 'Download Audio', onClick: handleDownloadAudio })
  }

  if (audioError) {
    actions.push({ label: 'Audio File Unavailable', disabled: true })
  }

  if (showDownloadTranscriptOption) {
    actions.push({ label: 'Download Transcript', onClick: handleDownloadTranscript })
  }

  if (showDownloadScreenCaptureOption) {
    actions.push({
      label: `Download ${pluralize('Screen Capture', videoUrls.length, false)}`,
      onClick: handleDownloadScreenCapture,
    })
  }

  if (videoError) {
    actions.push({ label: 'Screen Capture Unavailable', disabled: true })
  }

  return <ActionsDropdown actions={actions} dataTestId="download-audio-transcript-dropdown" />
}
